import { Box, Typography } from '@project44/manifest-ds';

import { scopedT } from '../../utils/helpers/scopedT';
import ArrowIcon from './icon';
import Logo from './logo';

import { Container, LearnMoreButton } from './styles';

export const PromoPanel = () => {
  const t = scopedT();

  const learnMoreClick = () => {
    window.open(
      'https://joinmovement.project44.com',
      '_blank',
      'noopener=true',
    );
  };

  return (
    <Container data-testid="movement-promo">
      <Box>
        <Logo />
      </Box>
      <Typography
        variant="display"
        css={{
          textAlign: 'center',
          color: '$text-contrast',
          marginTop: '4.5rem',
          marginBottom: '2rem',
        }}
      >
        {t('joinMovementToday')}
      </Typography>
      <Typography
        variant="body"
        css={{
          textAlign: 'center',
          color: '$text-contrast',
          marginBottom: '3rem',
          width: '483px',
        }}
      >
        {t('aboutMovement')}
      </Typography>
      <LearnMoreButton
        data-testid="movement-promo-learn-more"
        variant="brand"
        endIcon={<ArrowIcon />}
        onClick={learnMoreClick}
      >
        {t('learnMore')}
      </LearnMoreButton>
    </Container>
  );
};

export default PromoPanel;
